export const CHART_PALETTE = [
  '#21b3ff',
  '#00c100',
  '#f7cb00',
  '#ff6a16',
  '#c62828',
  '#9c27b0',
  '#00bcd4',
  '#4caf50',
  '#ff5722',
  '#607d8b',
] as const;

export const VARIANCE_ENTERED_COLOR = '#64B5F6';
export const VARIANCE_CLOSED_COLOR_LIGHT = '#111111';
export const VARIANCE_CLOSED_COLOR_DARK = '#6b7280';
export const VARIANCE_LINE_COLOR_ENTERED = '#1a1a1a';
export const VARIANCE_YEAR_LABEL_COLOR = '#9ca3af';

export const DOUGHNUT_CENTER_COLOR = '#21b3ff';
export const DOUGHNUT_MAX_ITEMS = 5;
export const DOUGHNUT_MIN_PCT_LABEL = 5;
export const DOUGHNUT_LABEL_MAX_CHARS = 22;

export const BAR_PERCENTAGE = 1.0;
export const BAR_CATEGORY_PERCENTAGE = 0.55;
